import { useRef, useEffect } from 'react';


// Custom Hook for referencing the previous value of a variable
export const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
